import _inheritsLoose from "@babel/runtime-corejs3/helpers/inheritsLoose";
import _concatInstanceProperty from "@babel/runtime-corejs3/core-js/instance/concat";
import { __decorate } from "tslib";
import { Component, createRef } from 'intact-vue';
import template from './index.vdt';
import { sizes } from '../../styles/utils';
import { bind } from '../utils';
import { useDraggable } from './useDraggable';
import { useConfigContext } from '../config';
var typeDefs = {
  name: String,
  on: String,
  off: String,
  value: null,
  trueValue: null,
  falseValue: null,
  width: [Number, String],
  height: [Number, String],
  size: sizes,
  disabled: Boolean
};
var defaults = function defaults() {
  return {
    value: false,
    trueValue: true,
    falseValue: false,
    size: 'default'
  };
};
var events = {
  click: true,
  keypress: true
};
export var Switch = /*#__PURE__*/function (_Component) {
  _inheritsLoose(Switch, _Component);
  function Switch() {
    var _context;
    var _this;
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _Component.call.apply(_Component, _concatInstanceProperty(_context = [this]).call(_context, args)) || this;
    _this.elementRef = createRef();
    _this.draggable = useDraggable(_this.elementRef);
    _this.config = useConfigContext();
    return _this;
  }
  var _proto = Switch.prototype;
  _proto.onClick = function onClick(e) {
    if (!e._switchIgnore) {
      this.toggle(false);
    }
    this.trigger('click', e);
  };
  _proto.onClickOnHandle = function onClickOnHandle(e) {
    // we can not stop propagation, otherwise the click can not be listen at outer
    e._switchIgnore = true;
  };
  _proto.onKeypress = function onKeypress(e) {
    this.trigger('keypress', e);
    if (e.keyCode === 13) {
      this.toggle(true);
    }
  };
  _proto.toggle = function toggle(isKeypress) {
    if (this.get('disabled')) return;
    // if is not keypress, we blur it to remove focus style
    if (!isKeypress) {
      this.elementRef.value.blur();
    }
    if (this.isChecked()) {
      this.uncheck();
    } else {
      this.check();
    }
  };
  _proto.isChecked = function isChecked() {
    return this.get('value') === this.get('trueValue');
  };
  _proto.check = function check() {
    this.set('value', this.get('trueValue'));
  };
  _proto.uncheck = function uncheck() {
    this.set('value', this.get('falseValue'));
  };
  return Switch;
}(Component);
Switch.template = template;
Switch.typeDefs = typeDefs;
Switch.defaults = defaults;
Switch.events = events;
__decorate([bind], Switch.prototype, "onClick", null);
__decorate([bind], Switch.prototype, "onClickOnHandle", null);
__decorate([bind], Switch.prototype, "onKeypress", null);